export default "__VITE_ASSET__DDplluX1__"